import Create from './Create.container';

export default Create;
